<template>
  <v-app id="app">
    <v-main class="mt-5">
      <v-container>
        <PlasmicRootProvider :loader="this.loader">
          <Authenticator>
            <router-view />
          </Authenticator>
        </PlasmicRootProvider>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { API } from 'aws-amplify'
import LogRocket from 'logrocket';
import { onAuthUIStateChange } from '@aws-amplify/ui-components'
import { PlasmicRootProvider } from '@plasmicapp/loader-vue';
import { PLASMIC } from './plasmic-init';
import Authenticator from './components/Authenticator'

export default {
  name: 'App',
  components: { Authenticator, PlasmicRootProvider },
  metaInfo: {
    title: 'Golden Dragon',
    viewport: 'width=device-width, initial-scale=1, shrink-to-fit=no'
  },
  methods: {
    windowResized() {
      this.$store.commit('setWindowWidth', window.innerWidth)
    }
  },
  computed: {
    loader() {
      return PLASMIC;
    }
  },
  created() {
    LogRocket.init('golden-dragon/portal');

    API.get('priority', '/apiv1/books/categories').then(res => {
      this.$store.commit('setBooksCategories', res)
    })

    onAuthUIStateChange((authState, authData) => {
      this.$store.commit('setAuthState', authState)
      this.$store.commit('setCurrAuthUser', authData)
      this.$gtag.event(authState, authData);

      if (authState === 'signedin') {
        API.get('priority', '/apiv1/app_data', null).then(res => {
          this.$store.commit('setAppData', res)
        })

        this.$gtag.set('user', authData);

        LogRocket.identify(authData.attributes.email, authData.attributes);
      } else {
        this.$store.commit('setUser', null)
      }
    })
    window.addEventListener('resize', this.windowResized)
  },
  destroyed() {
    window.removeEventListener("resize", this.windowResized)
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0 0.1rem;
}

.header {
  margin-top: 1rem;
  margin-bottom: 1rem
}

.theme--light {
  background: #FFE5B4 !important;
}

.v-pagination__item,
.v-pagination__navigation {
  background: #ffe1a8 !important
}
</style>
